module.exports = __webpack_public_path__ + "static/media/loading.6dd1ccba.gif";